import { contactTextFn } from '../../flows/shared/utils';

export const rolloverGuideFAQ = [
  {
    question: 'What is my eligibility date for a rollover?​​​​​​​',
    answer:
      'If you’re not eligible yet, make note of the date you are and contact your provider then to make the rollover request.'
  },
  {
    question: 'Is a Letter of Acceptance required?',
    answer: `If the answer is yes, we need to know so that we can generate it for you. Then, we can either send it to you or to the current provider on your behalf. Call a member of the rollover assistance team at ${contactTextFn(
      'rolloverCallAssistancePhone'
    )(0)} and let them know so they can assist you.`
  },
  {
    question: 'Do you offer paperless distributions?',
    answer:
      'If the answer is yes, this would mean less paperwork and the ability to initiate the rollover right on the call.'
  },
  {
    question: 'Is it possible to fax a request?',
    answer:
      'Some companies still use fax as a way of communicating. Knowing this upfront is helpful and can expedite your request.'
  },
  {
    question: 'Are there any other requirements?​​​​​​​',
    answer: 'Your provider might have other requirements not listed here.'
  }
];
